import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const labelVariants = cva(
  'block font-medium text-gray-700 dark:text-gray-300',
  {
    variants: {
      size: {
        sm: 'text-sm mb-1.5',
        md: 'text-sm mb-2',
        lg: 'text-base mb-2.5',
      },
      required: {
        true: "after:ml-0.5 after:text-error-500 after:content-['*']",
        false: '',
      },
    },
    defaultVariants: {
      size: 'md',
      required: false,
    },
  }
);

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof labelVariants> {}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, size, required, ...props }, ref) => {
    return (
      <label
        className={cn(labelVariants({ size, required, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);

Label.displayName = 'Label';
